import Typography from "../typography/typography";
import "./header-card.scss";
import logo from "../../assets/images";
import viewTypes from "../../constants/action-bar";
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material';

interface HeaderCard {
  title: string;
  active: string;
  onClick: () => void;
  key: number;
}

const HeaderCard = (props: HeaderCard) => {
  const { title, active, onClick, key, ...rest } = props;
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <div
      key={key}
      className={
        active && title.includes(active)
          ? "header-card header-card--Active"
          : "header-card"
      }
      onClick={onClick}
      {...rest}
    >
      {title && title === viewTypes.TABLE ? (
        <logo.TableIcon />
      ) : title === viewTypes.GRID ? (
        <logo.GridIcon />
      ) : title === viewTypes.GANTT ? (
        <logo.GanttIcon />
      ) : title === viewTypes.CALENDAR ? (
        <logo.CalenderIcon />
      ) : title === viewTypes.KANBAN ? (
        <logo.KanbanIcon />
      ) : title === viewTypes.CHART ? (
        <logo.ChartIcon />
      ) : (
        ""
      )}
      {isMdUp && 
        <Typography type="s3" color="inherit">
          {title} View
        </Typography>
      }
    </div>
  );
};

export { HeaderCard };
export default HeaderCard;
